export default __webpack_public_path__ + "static/media/CarinaLovelace.f3e3aec6.png";